'use strict';

const getCookie = require('util/getCookie');
const cookies = require('js-cookie');
const exchangeMode = 67;

const cookieSettings = {
    expires: 30, // number of days cookie will be valid for
    path: '/',
    domain: '.' + window.location.hostname.split('.').slice(1).join('.'),
};

function controller($sce, $http, $window, appConfig) {
    const vm = this;

    vm.promo_code = false;

    function init() {
        try {
            const mos_data = getCookie(document.cookie, 'mos');

            if (mos_data) {
                vm.mos_data = JSON.parse(decodeURIComponent(decodeURIComponent(mos_data)));

                if (parseInt(vm.mos_data.mos, 10) == exchangeMode) {
                    vm.is_exchange_mode = true;
                } else {
                    if (vm.mos_data.promo_code) {
                        vm.promo_code = vm.mos_data.promo_code;
                        if(vm.mos_data.promo_text) {
                            vm.description = $sce.trustAsHtml(vm.mos_data.promo_text.replace(/\+/g, ' '));
                        }
                    } else {
                        vm.promo_code = null;
                        vm.description = null;
                    }
                }
            } else {
                vm.promo_code = null;
                vm.description = null;
            }
        } catch (e) {
            console.warn('error initialising promo bar – this error is being caught so we don\'t show the bar in a bugged/broken state');
        }
    }

    vm.removePromo = () => {
        $http.get(
            `${appConfig.ticketingEndpoint}/api/promocode/remove`,
            {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                }
            }
        ).then(response => {
            if (response.data.status === 'ok') {
                cookies.set('mos', {}, cookieSettings);
                $window.location.reload();
            } else if (response.data.message) {
                alert(response.data.message);
            }
        });
    }

    vm.cancelOrder = () => {
        $window.location.href = `${appConfig.ticketingEndpoint}/booking/cancel-order`;
    }

    init();

    return vm;
}

module.exports = [
    '$sce',
    '$http',
    '$window',
    'appConfig',
    controller,
]



// WEBPACK FOOTER //
// ./widgets/controllers/PromoNotice.js